import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { ApiPaths } from "../../../api/paths";
import CustomButton from "../../../components/custom-button/CustomButton";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import useMutateData from "../../../hooks/use-mutate-data";

type Props = {
  selectedItem: any;
  show: boolean;
  onHide: () => void;
  onSuccess: () => void;
};

export default function DeleteWalletItem({
  show,
  onHide,
  onSuccess,
  selectedItem,
}: Props) {
  const { t } = useTranslation(["common", "myProfile"]);
  const { mutate, loading: deleteLoading } = useMutateData(
    `${ApiPaths.wallets}/${selectedItem?._id}`,
    {
      method: "DELETE",
      onError: () => {
        toast(t("delete_wallet.error", { ns: "myProfile" }), {
          type: "error",
          toastId: "cart-delete",
        });
      },
      onSuccess: () => {
        toast(t("delete_wallet.success", { ns: "myProfile" }), {
          type: "success",
        });
        onSuccess();
        onHide();
      },
    }
  );
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="text-center d-flex flex-column align-items-center p-5">
        <h2 className="primary-modal-title modal-danger-title mb-4">
          {t("delete_wallet.heading", { ns: "myProfile" })}
        </h2>
        <div className="cancel-policy-icon-cont delete-icon-cont rounded-circle mb-4">
          <DeleteIcon />
        </div>
        <p className="mb-4">
          {t("delete_wallet.message", {
            ns: "myProfile",
            wallet: selectedItem?._id,
          })}
        </p>
        <div className="d-flex justify-content-center align-items-center">
          <button
            className="modal-primary-button modal-secondary-button me-4"
            onClick={onHide}
          >
            {t("button.cancel", { ns: "common" })}
          </button>
          <CustomButton
            className="modal-primary-button"
            onClick={() => mutate()}
            loading={deleteLoading}
          >
            {t("button.confirm", { ns: "common" })}
          </CustomButton>
        </div>
      </Modal.Body>
    </Modal>
  );
}
